<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-location"></i>
              客户地址管理
            </h1>
            <p class="page-subtitle">管理客户收货地址信息，支持查看和编辑操作</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="返回客户列表" placement="top">
              <el-button 
                type="primary" 
                size="medium" 
                icon="el-icon-back" 
                @click="returnRolesList"
                class="back-btn">
                返回列表
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
        <ApeTable ref="apeTable" :data="list"  :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
          <el-table-column
              width="80"
            label="序号">
            <template slot-scope="scope">
                <span class="row-number">{{offset+scope.$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="收件人">
            <template slot-scope="scope">
                <div class="name-info">
                  <i class="el-icon-user"></i>
                  <span>{{scope.row.first_name}} {{scope.row.last_name}}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
              label="联系方式">
            <template slot-scope="scope">
                <div class="contact-info">
                  <p><i class="el-icon-message"></i> {{scope.row.email}}</p>
                  <p><i class="el-icon-phone"></i> {{scope.row.phone_number}}</p>
                </div>
            </template>
          </el-table-column>
          <el-table-column
              label="行业/国家">
            <template slot-scope="scope">
                <div class="location-info">
                  <p><i class="el-icon-office-building"></i> {{scope.row.industry}}</p>
                  <p><i class="el-icon-location-outline"></i> {{scope.row.country}}</p>
                </div>
            </template>
          </el-table-column>
          <el-table-column
              label="地址信息">
            <template slot-scope="scope">
                <div class="address-info">
                  <p><strong>区域：</strong>{{scope.row.state}}</p>
                  <p><strong>地址：</strong>{{scope.row.address}}</p>
                  <p><strong>邮编：</strong>{{scope.row.postcode}}</p>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            label="状态">
            <template slot-scope="scope">
                <div class="status-info">
                  <el-tag 
                    :type="scope.row.address_status=='1' ? 'success' : scope.row.address_status=='0' ? 'danger' : 'warning'"
                    size="small">
               <span v-if="scope.row.address_status=='0'">禁用</span>
               <span v-else-if="scope.row.address_status=='1'">启用</span>
               <span v-else>默认</span>
                  </el-tag>
                  <el-tag 
                    v-if="scope.row.is_default=='1'"
                    type="primary" 
                    size="mini" 
                    style="margin-top: 4px;">
                    默认地址
                  </el-tag>
                </div>
            </template>
          </el-table-column>
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ModalDialog :dialog-data="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="rolesUserForm" label-position="right" label-width="80px">
          <el-form-item label="选择用户" prop="mobile">
            <el-autocomplete
              v-model="formData.mobile"
              :fetch-suggestions="searchUser"
              placeholder="输入工号检索用户"
              @select="handleUserSelect"
              @clear="initMobileVerify"
              clearable>
            </el-autocomplete>
          </el-form-item>
        </el-form>        
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog
  },
  data() {
    return {
      loadingStaus: true,
      dialogData:{
        visible: false,
        title: '',
        width: '360px',
        loading: true,
        loading_text: '',
        modal: true
      },
      // 表格列表数据
      list:[],
      // 分页信息
      pagingData:{
        is_show: true,
        page_size: 20,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      searchCondition:{
        "current_page": 1,
        "page_size": 20,
        "query":"customer_id=?",
        "params":[]
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {id:''},
      // 表单验证
      rules: {
        mobile: [
          {required: true, message: '选择用户', trigger: 'blur', validator:this.autocompleteVerify },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 切换页码操作
    async switchPaging() {
      this.initlist()
    },
    // 响应添加按钮
    async addButton() {
      this.dialogData.visible = true
      this.dialogData.title = '添加成员'
      this.dialogData.loading = false
    },
    // 搜索用户,qs请求参数，cb回调函数，详见组件用法
    async searchUser(qs, cb) {
      if(qs==null){
        qs = ""
      }
      let params={
          query:"instr(first_name,?) or instr(last_name,?) or instr(email,?) or instr(mobile,?)",
          params:[qs,qs,qs,qs]
      }
      let {list} = await this.$api.getCustomers(params)
      for (let i = 0, len = list.length; i < len; i++) {
          list[i].value = list[i].mobile;           
      }
      cb(list)
      
    },
    // 处理搜索结果的选中
    handleUserSelect(item) {
      this.formData = item
      if (this.formData) {
        this.$refs['rolesUserForm'].validateField('mobile')
      }
    },
    // 初始化验证
    initMobileVerify() {
      this.formData.id = ''
      this.$refs['rolesUserForm'].validateField('mobile')
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['rolesUserForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initFormData()
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '玩命提交中……'
      this.dialogData.loading = true
      let data = {customer_id:parseInt(this.$route.params.id)}
      await this.$api.addCustomerAddress(data)
      this.$nextTick(() => {
        this.dialogData.visible = false
      })
      this.$nextTick(async () => {
          this.initlist()
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应移除按钮
    async removeButton(row) {
      let info = await this.$api.deleteCustomerAddress(row.id)
      if (info==null) {
        this.$nextTick(async () => {
          this.initlist('del')
        })
      } else {
        this.$message.error(info)
      } 
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.formData = {user_id:''}
        this.$refs['rolesUserForm'].resetFields()
      })
    },
    // 初始化用户列表
    async initlist(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      Object.assign(this.searchCondition,pagingInfo)
      this.searchCondition.params=[this.$route.params.id]
      this.searchCondition.query = 'customer_id=?'
      let res= await this.$api.post('/service/ola_app_customer_address/list',this.searchCondition)
      if (this.$apiSuccess(res)){
          this.list=res.data.list
          this.pagingData.total = res.data.page.total
      }else{
        this.$message.error(res.message)
        return
      }
      this.loadingStaus=false
    },
    // 搜索用户，自动补全验证
    autocompleteVerify(rule, value, callback) {
      if (rule.required && (!this.formData.id || !this.formData.mobile) ) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 返回角色列表
    returnRolesList() {
      this.$router.push('/customer/list/')
    }
    
  },
  mounted() {
    this.initlist()
  },
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px
    
    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 操作面板
  .action-card
    background white
    border-radius 12px
    padding 20px 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .action-buttons
    display flex
    gap 12px
    align-items center

  .back-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 10px 20px
    font-weight 500
    transition all 0.3s ease
    
    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  // 序号样式
  .row-number
    font-weight 600
    color #667eea
    background #f0f4ff
    padding 4px 8px
    border-radius 4px
    font-size 12px

  // 姓名信息
  .name-info
    display flex
    align-items center
    gap 8px
    
    i
      color #667eea
      font-size 16px
    
    span
      font-weight 500
      color #1f2937

  // 联系方式信息
  .contact-info
    p
      margin 2px 0
      display flex
      align-items center
      gap 6px
      font-size 13px
      
      i
        color #6b7280
        width 14px

  // 位置信息
  .location-info
    p
      margin 2px 0
      display flex
      align-items center
      gap 6px
      font-size 13px
      
      i
        color #6b7280
        width 14px

  // 地址信息
  .address-info
    p
      margin 2px 0
      font-size 13px
      line-height 1.4
      
      strong
        color #374151
        font-weight 600

  // 状态信息
  .status-info
    display flex
    flex-direction column
    align-items flex-start
    gap 4px

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb
      
    td
      border-bottom 1px solid #f3f4f6
      
    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px
      
    .page-title-section
      padding 24px 20px
      
    .page-title
    font-size 24px
      
    .action-card, .table-card
      padding 16px
      
    .contact-info, .location-info, .address-info
      p
        font-size 12px
</style>
